import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../utils/page-auth';
import { Helmet } from 'react-helmet';
import { getTokenTypeName, SELECT_FORM_STYLE, TOKEN_TYPES } from '../../../constants/base';
import {
  ContentsWalletListRequest,
  depositAddressRequest,
  depositRequest
} from '../../../redux/actions/wallet/depositActions';
import Notification from '../../../components/Notification/Notification';
import commonIcons from '../../../api/images/icons';
import changeNumApi from '../../../api/ui/changeNumApi';
import WalletBalanceTable from "./WalletBalanceTable";
import useEtherWalletConnect from "../../../api/wallet/etherWalletConnect";
import useEtherTokenTransfer from "../../../api/wallet/etherTransferEvent";

function DepositMain() {
  // -- component const --//
  const title = '입금 처리';

  const { connectWallet, isConnected, account } = useEtherWalletConnect();
  const transferToken = useEtherTokenTransfer();
  let txHash = null;
  let transactionResult = false;

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const [walletNo, setWalletNo] = useState(107);
  const [walletList, setWalletList] = useState([]);
  const [eventToken, setEventTokens] = useState('');
  const [amount, setAmount] = useState(0);

  // 전송 주소 설정
  const [address, setAddress] = useState('');

  // 승인 버튼 제어
  const [btnState, setBtnState] = useState(false);

  // -- func & handler --//
  // 지갑 연동
  const handleConnect = async () => {
    if (!isConnected) {
      await connectWallet();
    }
  };

  // 입금처리
  const handleApproveEvent = async () => {
    setBtnState(true);

    if (!isConnected) {
      alert('지갑 연동을 먼저 해주세요!');
      await connectWallet();
    }

    console.log(account);

    dispatch(depositRequest({
      walletNo: walletNo,
      tokenType: eventToken,
      amount: parseFloat(changeNumApi.mul18(amount)),
      walletAddress: account,
      callback: async (data) => {
        console.log('요청 결과: ', data);

        const tokenType = getTokenTypeName(eventToken);

        const result = await transferToken(tokenType, address, amount);
        // approveEvent 함수에서 반환된 값 출력
        console.log('transactionResult:', result);

        // txHash와 transactionResult를 변수에 할당 (필요하다면 다른 곳에서 사용할 수 있음)
        txHash = result.txHash;
        transactionResult = result.transactionResult;

        if (transactionResult) {
          console.log('transactionResult 전송');

          setNotificationMessage('입금 처리 승인 성공');
          setShowNotification(true);

          setTimeout(() => {
            setAddress('');
            setAmount(0);
            setEventTokens(null);
            setBtnState(false);
          }, 1000)
        } else {
          setBtnState(false);
          // setNotificationMessage(`사유: ${}로 실패했습니다.`);
          setShowNotification(true);
        }
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);
        setBtnState(false)
      },
    }))
  };

  // -- react hooks --//
  useEffect(() => {
    dispatch(ContentsWalletListRequest({
      callback: (data) => {
        console.log('요청 결과: ', data);
        setWalletList(data.list);
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);
      },
    }));
  }, []);

  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  // -- render --//
  return (
    <div className='page'>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSection">
        <p className="titleText">
          {title}
          {readOnly ? '(읽기전용)' : ''}
        </p>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea paddingAll">

        <div className="rowDiv flex">
          <div className="titleDiv">
            <p style={{ color: '#E90A32' }}>
              * 지갑 번호 *
            </p>

            <div className="spaceDiv10"/>

            <select
                className=""
                value={walletNo === 0 ? '' : walletNo}
                onChange={(e) => {
                  setWalletNo(Number(e.target.value));
                  setAddress('');
                }}
                disabled={readOnly}
            >
              <option value="" disabled>
                주문 번호
              </option>
              {walletList?.map((wallet) => (
                  <option key={wallet.walletNo} value={wallet.walletNo}>
                    {wallet.walletDesc} ({wallet.walletNo})
                  </option>
              ))}
            </select>
          </div>

          <div className="titleDiv">
            <p style={{ color: '#E90A32' }}>
              * 토큰 종류 *
            </p>

            <div className="spaceDiv10"/>

            <select
              className=""
              value={eventToken || ''}
              style={SELECT_FORM_STYLE}
              onChange={(e) => {
                setEventTokens(Number(e.target.value));
              }}
              disabled={readOnly}
            >
              <option value={''} disabled>
                입금 할 토큰 종류
              </option>
              {TOKEN_TYPES
                .filter(type => type?.key !== 100 && type?.key !== 200 && type?.key !== 3 && type?.key !== 4)
                .map((option) => (
                <option key={option.key} value={option.key}>
                  {option.value}
                </option>
              ))}
            </select>
          </div>

          <div className="titleDiv">
            <p style={{ color: '#E90A32' }}>
              * 입금 할 금액 *
            </p>

            <div className="spaceDiv10"/>

            <input
              className=""
              value={amount === 0 ? '' : amount}
              placeholder="입금 할 금액 입력"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              disabled={readOnly}
            />
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">
          <button
            className="error"
            onClick={() => handleConnect()}
            disabled={readOnly}
          >
            { commonIcons.alertIcon } 지갑 연결 { commonIcons.alertIcon }
          </button>
          <button
            className="purple"
            onClick={() => {
              dispatch(depositAddressRequest({
                walletNo: walletNo,
                callback: (data) => {
                  console.log('요청 결과: ', data);
                  setAddress(data.address);
                },
                error: (e) => {
                  console.log(e);
                  setNotificationMessage(e.toString());
                  setShowNotification(true);
                }
              }));

              // dispatch(
              //     walletInfoListRequest({
              //       page: Number(1),
              //       pageLength: Number(1),
              //       account: '100',
              //       walletNo: walletNo,
              //       callback: (data) => {
              //         console.log(data);
              //         setBalances({
              //           HVH: data?.list[0]?.balanceHvh,
              //           ARB: data?.list[0]?.balanceArb,
              //           PER: data?.list[0]?.balancePer,
              //           XPER: data?.list[0]?.balanceXper,
              //           USDT: data?.list[0]?.balanceUsdt,
              //         });
              //       },
              //       error: (e) => {
              //         console.log(e);
              //         setNotificationMessage(e.toString());
              //         setShowNotification(true);
              //       },
              //     }),
              // );
            }}
            disabled={readOnly}
          >
            지갑주소 가져오기
          </button>

          <button
            className="error"
            onClick={handleApproveEvent}
            disabled={readOnly || btnState || !address}
          >
            { commonIcons.warningIcon } 입금 처리 및 정보 서버 전송 { commonIcons.warningIcon }
          </button>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">
          <div className="titleDiv">
            <p>
              { `버튼을 왼쪽에서부터 순서대로 눌러 진행하세요.` }
            </p>
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">
          <div className="titleDiv">
            <p style={{ color: '#E90A32' }}>
              { `지갑 번호: ${walletNo} 에 해당하는 지갑 주소: ${address ? address : `${commonIcons.alertIcon} [지갑주소 가져오기]버튼을 눌러주세요 ${commonIcons.alertIcon} 전송 할 지갑주소 불러오지 못 한 경우 처리버튼 비활성화 ${commonIcons.alertIcon}`}` }
            </p>
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex">
          <div className="titleDiv">
            <p style={{ color: '#E90A32' }}>
              { `지갑 잔액 정보 (입금 전 확인) `  }
            </p>
          </div>
        </div>

        <div className="spaceDiv10"/>

        {/* New section to display balance information */}
        <WalletBalanceTable walletList={walletList} />

      </div>

      {
        showNotification ? (
          <Notification
            close={() => setShowNotification(false)}
            message={notificationMessage}
          />
        ) : null
      }

    </div>
  )
}

export default DepositMain;
